const dealers = {
  dealers: 'Dealers',
  new_dealer: 'New Dealer',
  add_emp: 'New Employee',
  edit_emp: 'Employee',
  search_dealers: 'Search Dealers',
  search_employee: 'Search Employees',
  delete_dealers_message: 'Are you sure you want to delete',
  confirm_modal_confirm: 'Yes, delete',
  update_dealer: 'Dealer',
  dealer_info: 'Dealer Info',
  all: 'All',
  active: 'Active',
  inactive: 'Inactive',
  submit: 'Submit',
  update: 'Update',
  edit: 'Edit',
  organizations: 'Accounts',
  controllers: 'Controllers',
  emp_role: 'Employee Role',
  select_dealer_msg: 'Please go to Dealers and select one',
  confirm_action: 'Are you sure you want to change the status to',
  card_enrollment: 'Credential Enrollment',
  card_information: 'Credential Information',
  how_you_discover: 'How did you discover CDVI Cloud',
  dealer_registration: 'Dealer Registration',
  table: {
    company: 'COMPANY',
    full_name: 'FULL NAME',
    email: 'EMAIL',
    country: 'COUNTRY',
    last_login: 'LAST LOGIN',
    active: 'ACTIVE',
  },
  form: {
    logo: 'Logo',
    website: 'Website',
    mobile: 'Mobile',
    language: 'Communication Language',
  },
  error: {
    invalid_email: 'Invalid email format',
    invalid_zip: 'Invalid zip code',
  },
  preregistration_success:
    'We have sent you a link to complete the registration to your email',
  preregistration_error:
    'Unable to complete your request. Please try again later.',
  request: {
    back_to_home: 'Back to home',
    error: 'An error has occurred.',
    msg1: 'We have received your request to become a dealer.',
    msg2: 'We will contact you by email soon!',
    thank_you: 'Thank you, {{ companyName }}!',
  },
  tabs: {
    employees: 'Employees',
    payment_methods: 'Payment methods',
  },
  resend_invitation: 'Re-send invitation',
  status_changed_successfully: 'Status Changed Successfully',
  dealer_user: {
    no_associated_account:
      'No account associated. Please contact your dealer to assign one to you.',
  },
};

export default dealers;
